import { createActions } from '../../context';
import * as actions from './jobstatus.actions';

export const jobStatus = store => ({
    pagination: {
        currentPage: 1,
        pageSize: 10,
        pagesCount: 1,
        itemsCount: 0
    },
    items: [],
    actions: createActions(actions)(store)
});